(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("layer-ordering", [], factory);
	else if(typeof exports === 'object')
		exports["layer-ordering"] = factory();
	else
		root["layer-ordering"] = factory();
})(self, function() {
return 